'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _uniqBy2 = require('lodash/uniqBy');

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _listings = require('../actions/listings');

var _listings2 = require('../transformers/listings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popularConditionsNames = ['Asthma', 'Infertility'];
var popularProceduresNames = ['Mole removal', 'Breast Reduction', 'Anterior cruciate ligament (ACL) reconstruction'];

var INITIAL_STATE = {
	insurers: [],
	languages: [],
	procedures: [],
	conditions: [],
	specialties: [],
	professionalBodies: [],
	scansTreatmentGroups: [],
	healthChecksTreatmentGroups: [],
	popularConditions: [],
	popularProcedures: []
};

var filterArrayByItemsNames = function filterArrayByItemsNames(array, names) {
	var newArray = array;

	if (names.length) {
		newArray = array.filter(function (item) {
			return names.indexOf(item.name) > -1;
		});
	}
	return (0, _uniqBy3.default)(newArray, 'name');
};

var flattenSpecialties = function flattenSpecialties(specialties) {
	var flattenedSpecialties = [];
	specialties.forEach(function (specialty) {
		flattenedSpecialties.push(specialty);
		if (specialty.children) {
			Array.prototype.push.apply(flattenedSpecialties, flattenSpecialties(specialty.children));
		}
	});
	return flattenedSpecialties;
};

// Near duplicate of code above - slight different filtering/logic in each.
var flattenHealthChecks = function flattenHealthChecks(healthChecks) {
	var flattenedHealthChecks = [];
	healthChecks.forEach(function (healthCheck) {
		if (healthCheck.has_practices || healthCheck.has_specialists) {
			flattenedHealthChecks.push(healthCheck);
		}
		if (healthCheck.children) {
			Array.prototype.push.apply(flattenedHealthChecks, flattenHealthChecks(healthCheck.children));
		}
	});
	return flattenedHealthChecks;
};

var listings = function listings(state, action) {
	switch (action.type) {
		case _listings.INSURERS + '_RECEIVED':
			return Object.assign({}, state, { insurers: action.response });
		case _listings.LANGUAGES + '_RECEIVED':
			return Object.assign({}, state, { languages: action.response });
		case _listings.PROCEDURES + '_RECEIVED':
			return Object.assign({}, state, {
				procedures: action.response,
				popularProcedures: filterArrayByItemsNames(action.response, popularProceduresNames)
			});
		case _listings.CONDITIONS + '_RECEIVED':
			return Object.assign({}, state, {
				conditions: action.response,
				popularConditions: filterArrayByItemsNames(action.response, popularConditionsNames)
			});

		case _listings.SPECIALISTS + '_RECEIVED':
			return Object.assign({}, state, {
				specialists: (0, _listings2.transformSearchResults)(action.response && action.response.search_results)
			});
		case _listings.PRACTICES + '_RECEIVED':
			return Object.assign({}, state, {
				practices: (0, _listings2.transformSearchResults)(action.response && action.response.search_results)
			});

		case _listings.SPECIALTIES + '_RECEIVED':
			{
				var flattenedSpecialties = flattenSpecialties(action.response);
				return Object.assign({}, state, { specialties: flattenedSpecialties, topLevelSpecialties: action.response });
			}
		case _listings.PROFESSIONAL_BODIES + '_RECEIVED':
			return Object.assign({}, state, { professionalBodies: action.response });
		case _listings.SCAN_TREATMENT_GROUPS + '_RECEIVED':
			return Object.assign({}, state, { scansTreatmentGroups: action.response });
		case _listings.HEALTH_CHECK_TREATMENT_GROUPS + '_RECEIVED':
			return Object.assign({}, state, { healthChecksTreatmentGroups: action.response });
		case _listings.HEALTH_CHECKS + '_RECEIVED':
			return Object.assign({}, state, { healthChecks: flattenHealthChecks(action.response) });
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = listings;